import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const farmerDetails = this.props.farmerDetails;
    const data = this.props.searchData;
    const accountDetails = this.props.accountDetails;

    return (
      <div align='left'>
        <h3><center><u>FDC 2nd Approved Farmer Details</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{data.groupName}</center></h4>
        <h4><center>Fresh Collection Center - {data.factoryID}</center></h4>
        <h4><center>Date - {data.date}</center></h4>
        <h4><center>Status - {data.statusID == 1 ? 'New' : data.statusID == 2 ? 'FCC Approved' : data.statusID == 3 ? 'FDC First Approved' : data.statusID == 4 ? 'FDC Second Approved' :
          data.statusID == 5 ? 'FCC Rejected' : data.statusID == 6 ? 'FDC First Rejected' : data.statusID == 7 ? 'FDC Second Rejected' : 'All Status'}</center></h4>
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Fresh Collection Center</TableCell>
                  <TableCell align={"left"}>Supplier Code-Agrithmics</TableCell>
                  <TableCell align={'left'}>Supplier Code-Navision</TableCell>
                  <TableCell align={'left'}>Supplier Full Name</TableCell>
                  <TableCell align={'left'}>NIC/BRN</TableCell>
                  <TableCell align={'left'}>Address line 1</TableCell>
                  <TableCell align={'left'}>Address line 2</TableCell>
                  <TableCell align={'left'}>Contact Number</TableCell>
                  <TableCell align={'left'}>Bank Account Number</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {farmerDetails.map((row, index) => (

                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.fcc == null | row.fcc == false ? '-' : row.fcc}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.farmerCode == null | row.farmerCode == false ? '-' : row.farmerCode}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.navisionNumber == null | row.navisionNumber == false ? '-' : row.navisionNumber}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.givenName == null | row.givenName == false ? '-' : row.givenName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.nic == null | row.nic == false ? '-' : row.nic}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.address1 == null | row.address1 == false ? '-' : row.address1}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.address2 == null | row.address2 == false ? '-' : row.address2}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.mobileNumber == null | row.mobileNumber == false ? '-' : row.mobileNumber}
                    </TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {(() => {
                      const filteredAccounts = accountDetails.filter(account => account.farmerID === row.farmerID);
                      if (filteredAccounts.length > 0) {
                        const defaultAccount = filteredAccounts.find(account => account.isDefault);
                        if (defaultAccount) {
                          return defaultAccount.accountNumber || '-';
                        } else {
                          return filteredAccounts[0].accountNumber || '-';
                        }
                      } else {
                        return "-";
                      }
                    })()}
                  </TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>

    );
  }
}
